<template>
    <div class="calendar-view">
        <div class="header">
          <MonthSelector @month-selected="onSelectedMonthChanged"></MonthSelector>
          <span class="title">{{ Authorization.accountName }}'s Team Calendar</span>
          <div class="legend">
            <div class="legend"> Out of Office:
              <CalendarDay :dayData="{ hours: null, isAbsent: false, outOfOffice: true, isPresent: false }" />
            </div>
            <div class="legend"> Absent:
              <CalendarDay :dayData="{ hours: null, isAbsent: true, outOfOffice: false, isPresent: false }" />            
            </div>
            <div class="legend"> Present:
              <CalendarDay :dayData="{ hours: null, isAbsent: false, outOfOffice: false, isPresent: true }" />
            </div>
          </div>
        </div>
        <CalendarTable :calendarData="calendarStore.getAll" :date="state.date"></CalendarTable>
    </div>
</template>

<script setup lang="ts">
import { Authorization } from "@/services/authenticate";
import { showToastError } from "@/toastification";
import { reactive, onBeforeMount } from "vue";
import { useCalendarStore } from "@/stores/calendar";
import CalendarTable from "../../components/Calendar/CalendarTable.vue";
import { parseError } from "@/common/util";
import CalendarDay from "../../components/Calendar/CalendarDay.vue";
import MonthSelector from "@/components/util/MonthSelector.vue";

const calendarStore = useCalendarStore();

const state = reactive({
  date: { year: (new Date).getFullYear(), month: (new Date).getMonth()},
  dailyCommitment: 0,
});

onBeforeMount(async () => {
  await loadMonth();
});

async function onSelectedMonthChanged(newDate: any) {
  state.date = newDate;
  await loadMonth();
}

async function loadMonth() {
  try {
    await calendarStore.loadCalendarMonth(
      state.date.year,
      state.date.month + 1,
      Authorization.id
    );  
  }
  catch (e) {
    console.error(e);
    showToastError("Report was unable to generate: " + parseError(e));
  }
  finally {
  }
}

</script>
<style scoped lang="scss">
.calendar-view {
  height: calc(100vh - 185px);
  overflow: auto;  
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: var(--color-bg-secondary);
  border-bottom: 1px solid var(--color-border);
}

.legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}
</style>